import React from 'react'
import {
  Button,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayContent,
  DialogOverlayFooter,
  Body1,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { Person } from '../types/persons'
import { getExternalBaseUrl } from '../services/url-service'
import { useDataContext } from '../services/data-service'

export default function NotPublished({
  person,
  overlay,
}: {
  person: Person
  overlay: Record<string, unknown>
}): JSX.Element {
  const [t] = useTranslation()
  const baseUrl = getExternalBaseUrl()
  const dataContext = useDataContext()
  const { store: dataState } = dataContext
  const { CF } = dataState
  return (
    <DialogOverlay {...overlay} headingText={person.name}>
      <DialogOverlayContent>
        <Body1>
          {CF
            ? t('ancestors.unavailable.text', 'This person is not available to view.')
            : t(
                'ancestors.person.not-published',
                'To see {personName}, please sign in or create a free FamilySearch Account.',
                {
                  personName: person.name,
                }
              )}
        </Body1>
      </DialogOverlayContent>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          {CF ? (
            <Button onClick={overlay.handleClick} data-testid="not-available-close">
              {t('common-ui:close.action', 'Close')}
            </Button>
          ) : (
            <>
              <Button
                to={`${baseUrl}/auth/familysearch/login?returnurl=${encodeURIComponent(
                  `${baseUrl}/tree/person/details/${person.id}`
                )}`}
                external
              >
                {t('common-ui:sign-in.action', 'Sign In')}
              </Button>
              <Button emphasis="high" to={`${baseUrl}/register`} external>
                {t('ancestors.create-free-account.action', 'Create a FREE Account')}
              </Button>
            </>
          )}
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
